module.exports = __webpack_public_path__ + "img/stripe-logo.d86aca66.svg";